// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorBoundary_wrapper__2vL-O","error":"ErrorBoundary_error__3pcHK","headerOverrides":"ErrorBoundary_headerOverrides__3oa_s","email":"ErrorBoundary_email__37Y5y"};